exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dragbar[data-v-7e27d7e2]{position:absolute;bottom:0;width:100%;height:7px;background-color:#e5e5e8;text-align:center;cursor:ns-resize}.hover[data-v-7e27d7e2]{height:13px}", ""]);

// exports
